export default __webpack_public_path__ + "static/media/chalk.2367bdd7.svg";